import React from "react";
import { ArrowRight, FileDown } from "lucide-react";
import { useContent } from "../contexts/ContentContext";
import { resolveAssetUrl } from "../lib/api";
import { useReservation } from "./ReservationDialog";

export default function Hero() {
    const { t, content } = useContent();
    const { setOpen } = useReservation();
    const heroImage = resolveAssetUrl(content?.hero_image);

    return (
        <section id="top" className="relative min-h-screen w-full overflow-hidden" data-testid="hero-section">
            <div
                className="absolute inset-0 bg-cover bg-center scale-105"
                style={{ backgroundImage: `url(${heroImage})` }}
            />
            <div className="absolute inset-0 hero-overlay" />
            <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 pt-36 pb-24 md:pt-44 md:pb-32 min-h-screen flex flex-col justify-center">
                <div className="max-w-3xl fade-in-up">
                    <span
                        className="inline-block text-[11px] md:text-xs uppercase tracking-[0.3em] font-semibold text-white/90 border border-white/40 rounded-full px-4 py-1.5 backdrop-blur-sm"
                        data-testid="hero-kicker"
                    >
                        {t?.hero?.kicker}
                    </span>
                    <h1
                        className="mt-8 text-white font-display font-light leading-[0.9] text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] tracking-tight"
                        style={{ textShadow: "0 4px 40px rgba(0,0,0,0.3)" }}
                        data-testid="hero-title"
                    >
                        {t?.hero?.title}
                    </h1>
                    <p
                        className="mt-8 text-white/95 text-lg md:text-xl max-w-2xl leading-relaxed"
                        data-testid="hero-subtitle"
                    >
                        {t?.hero?.subtitle}
                    </p>
                    <div className="mt-12 flex flex-wrap gap-4">
                        <button
                            type="button"
                            onClick={() => setOpen(true)}
                            className="btn-primary"
                            data-testid="hero-cta-reserve"
                        >
                            {t?.hero?.cta}
                            <ArrowRight size={16} />
                        </button>
                        <button
                            onClick={() => document.getElementById("menu")?.scrollIntoView({ behavior: "smooth" })}
                            className="hero-secondary-btn"
                            data-testid="hero-cta-menu"
                        >
                            {t?.hero?.cta_secondary}
                            <FileDown size={16} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2">
                <span className="text-[10px] uppercase tracking-[0.3em] text-white/70">Scroll</span>
                <div className="w-[1px] h-14 bg-white/50 animate-pulse" />
            </div>
        </section>
    );
}
